module.exports = __webpack_public_path__ + "img/side_slit_length.b000d00a.png";